import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentPromosComponent } from './payment-promos.component';
import { PaymentPromoCard } from './payment-cards/payment-promo-cards.component';
import { TextModule } from '../text/text.module';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentPromoBanner } from './payment-banners/payment-promo-banners.component';

@NgModule({
    declarations: [
        PaymentPromosComponent,
        PaymentPromoCard,
        PaymentPromoBanner,
    ],
    imports: [
        CommonModule,
        TextModule,
        TranslateModule,
    ],
    exports: [
        PaymentPromosComponent,
        TextModule,
    ]
})
export class PaymentPromosModule {}